import { useState } from 'react'
import { Typography } from '@mui/material'
import colors from 'styles/colors'
import RowStack from 'components/atoms/container/RowStack'
import BoxWithBackground from 'components/atoms/container/BoxWithBackground'
import { useTranslation } from 'react-i18next'
import { ColStack } from 'components/atoms/container/InCardStack'
import {
  CardTag,
  CardHeader,
  CardFooter,
  CardSkeleton
} from 'components/molecules/home/PathCardMolecules'
import PathCardActions from 'components/molecules/home/PathCardActions'
import PathDetailsPopup from './PathDetailsPopup'

const PathCard = ({ goal, isLibrary = false, sx = {} }) => {
  const { t } = useTranslation()
  const [openDetails, setOpenDetails] = useState(false)

  return (
    <>
      <BoxWithBackground
        onClick={() => setOpenDetails(true)}
        sx={{
          width: '100%',
          padding: 8,
          borderRadius: 3,
          backgroundColor:
            !isLibrary && !goal?.completed && goal?.overDue
              ? colors.Peach50
              : colors.White,
          boxShadow: '0px 1px 4px 0px rgba(0, 0, 0, 0.20)',
          '&:hover': {
            cursor: 'pointer',
            boxShadow: '0px 1px 12px 0px rgba(0, 0, 0, 0.20)',
            transition: 'box-shadow 0.3s ease-in-out'
          },
          ...sx
        }}>
        <ColStack spacing={16}>
          <ColStack spacing={8}>
            <CardHeader goal={goal} isLibrary={isLibrary} />

            <ColStack spacing={6}>
              <RowStack spacing={4}>
                {goal.virtues.length > 0 ? (
                  <>
                    <CardTag>{goal.virtues[0].name}</CardTag>
                    {goal.virtues.length > 1 && (
                      <CardTag>
                        +
                        {`${goal.virtues.length - 1} ${t('home.skill')}${goal.virtues.length > 2 ? 's' : ''}`}
                      </CardTag>
                    )}
                  </>
                ) : (
                  <>
                    <CardSkeleton w={112} h={24} />
                    <CardSkeleton w={60} h={24} />
                  </>
                )}
              </RowStack>
              <ColStack spacing={8}>
                <ColStack spacing={2}>
                  <Typography
                    variant='h4'
                    noWrap
                    sx={{
                      width: '100%',
                      overflow: 'hidden',
                      textOverflow: 'ellipsis'
                    }}>
                    {goal.name}
                  </Typography>
                  {goal.summary ? (
                    <Typography
                      variant='body1Small'
                      sx={{
                        color: colors.MidnightTeal300,
                        display: '-webkit-box',
                        overflow: 'hidden',
                        textOverflow: 'ellipsis',
                        WebkitLineClamp: 3,
                        WebkitBoxOrient: 'vertical',
                        height: '69px',
                        lineHeight: '23px' // Adjust line height (69px / 3 lines)
                      }}>
                      {goal.summary}
                    </Typography>
                  ) : (
                    <>
                      <CardSkeleton h={20.3} />
                      <CardSkeleton h={20.3} />
                      <CardSkeleton h={20.3} w={'60%'} />
                    </>
                  )}
                </ColStack>

                {!isLibrary && (
                  <PathCardActions
                    openPreview={() => setOpenDetails(true)}
                    goal={goal}
                    btnSize='small'
                    isLibrary={isLibrary}
                  />
                )}
              </ColStack>
            </ColStack>
          </ColStack>

          <CardFooter goal={goal} isLibrary={isLibrary} />
        </ColStack>
      </BoxWithBackground>
      {openDetails && (
        <PathDetailsPopup
          open={openDetails}
          onClose={() => setOpenDetails(false)}
          goal={goal}
          isLibrary={isLibrary}
        />
      )}
    </>
  )
}

export default PathCard
